import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider, ConfigProvider } from '@connor-music/shared';
import { CustomerAuthProvider } from '@/hooks/useAuth';
import { customerApiClient } from '@/services/api';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <ConfigProvider
          fetchPublicConfig={() => customerApiClient.getPublicConfig()}
        >
          <CustomerAuthProvider>
            <App />
            <Toaster position="top-right" />
          </CustomerAuthProvider>
        </ConfigProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
